/**
 * @generated SignedSource<<4b8b4f5adb729bfff6e83957619963bf>>
 * @relayHash d5964b17675dface7c955e123820fc56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a80e5382e65b1aa21b464421d4d12320cb2190631e40ce85962b1ed1e5b3b882

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a80e5382e65b1aa21b464421d4d12320cb2190631e40ce85962b1ed1e5b3b882",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
